import { fetchWithCredentials } from "../fetch";
import type {
  FetchLogoutConfigResult,
  IntegrationsClientInterface,
  IntegrationsClientOptions,
  LogoutConfigResponses,
} from "./types";

/**
 * This is an adaptor used to call SendGrid integrations/links API functions.
 */
export class IntegrationsClient implements IntegrationsClientInterface {
  // Properties
  private readonly options: IntegrationsClientOptions;
  private readonly baseURL: string;

  private readonly defaultOptions: Partial<IntegrationsClientOptions> = {
    baseURL: "https://links.integrations.sendgrid.net",
  };

  // Constructor provide the base url.
  constructor(options: IntegrationsClientOptions = {}) {
    this.options = {
      ...this.defaultOptions,
      ...options,
    };
    this.baseURL = getBaseURL(this.options.baseURL || "https://links.integrations.sendgrid.net");
  }

  async fetchLogoutConfig(): Promise<FetchLogoutConfigResult> {
    try {
      const response = await fetchWithCredentials(`${this.baseURL}/links.json`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        return { success: false };
      }

      const config = (await response.json()) as LogoutConfigResponses;
      return {
        success: true,
        config,
      };
    } catch (e) {
      return { success: false };
    }
  }
}

/**
 * @ignore
 */
const getBaseURL = (baseURL: string) => {
  if (!/^https?:\/\//i.test(baseURL)) {
    return `https://${baseURL}`;
  }

  return baseURL;
};
